<template>
  <div class="Trading">
    <MobileNav :page_title="nav_title"></MobileNav>

    <!-- set_active_link is event emitted frin home page sidebar -->
    <!-- <div class="sideBarSection">
      <PlainSideBar v-if="isDesktop"></PlainSideBar>
    </div> -->
    <el-row>
      <el-col :xs="2" :sm="2" :md="1" :lg="2" :xl="3">&nbsp;</el-col>
      <el-col :xs="24" :sm="24" :md="22" :lg="20" :xl="18">
        <div class="reco-details-container">
          <div class="sub-menu-section">
            <div class="sub-menu-bar-wrapper">
              <div class="sub-menu-bar">
                <div
                  class="sub-menu-bar-link cursor-pointer"
                  @click="setActiveSubMenuLink('TRADE')"
                  :class="{
                    'active-sub-menu-link': activeTradingMenu == 'TRADE',
                  }"
                >
                  Search Stock
                </div>

                <div
                  class="sub-menu-bar-link cursor-pointer"
                  @click="setActiveSubMenuLink('ORDERS')"
                  :class="{
                    'active-sub-menu-link': activeTradingMenu == 'ORDERS',
                  }"
                >
                  Orders
                </div>

                <div
                  class="sub-menu-bar-link cursor-pointer"
                  @click="setActiveSubMenuLink('POSITION')"
                  :class="{
                    'active-sub-menu-link': activeTradingMenu == 'POSITION',
                  }"
                >
                  Position
                </div>

                <div
                  class="sub-menu-bar-link cursor-pointer"
                  @click="setActiveSubMenuLink('HOLIDINGS')"
                  :class="{
                    'active-sub-menu-link': activeTradingMenu == 'HOLIDINGS',
                  }"
                >
                  Holdings
                </div>

                <div
                  class="sub-menu-bar-link cursor-pointer"
                  @click="setActiveSubMenuLink('FUNDS')"
                  :class="{
                    'active-sub-menu-link': activeTradingMenu == 'FUNDS',
                  }"
                >
                  Funds
                </div>
              </div>
            </div>
          </div>

          <div class="reco-details-section">
            <Trade v-if="activeTradingMenu == 'TRADE'" />

            <Orders v-if="activeTradingMenu == 'ORDERS'"></Orders>

            <Positions v-if="activeTradingMenu == 'POSITION'"></Positions>

            <Holdings v-if="activeTradingMenu == 'HOLIDINGS'"></Holdings>

            <Funds v-if="activeTradingMenu == 'FUNDS'"></Funds>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { serverAddr, serverHostName } from '../networkConfig';
import { filterCallBack } from '../mixins/filter';
import { HelperNetworkCallBack } from '../mixins/Helper';
import { screenSize } from '../mixins/ScreenSize.js';
import MobileNav from '@/components/MobileNav.vue';
import PlainSideBar from '@/components/PlainSideBar.vue';
import Trade from '@/components/Trade.vue';
import Orders from '@/components/Orders.vue';
import Positions from '@/components/Positions.vue';
import Holdings from '@/components/Holdings.vue';
import Funds from '@/components/Funds.vue';

export default {
  name: 'Trading',

  components: {
    MobileNav,
    PlainSideBar,
    Trade,
    Orders,
    Positions,
    Holdings,
    Funds,
  },

  mixins: [filterCallBack, HelperNetworkCallBack, screenSize],

  data() {
    return {
      nav_title: 'Trading',
      active_sub_menu_link: 'TRADE',
      profileId: null,
      // specificProfileIds: [26358, 26343, 6045, 37629, 37577, 37499, 34545, 28532, 26783, 26725, 23998, 5669,3928,],
    };
  },
  mounted() {
    const profile = JSON.parse(localStorage.getItem('profile'));

    // Convert profile.id into a number without specifying radix
    this.profileId = profile && profile.id ? parseInt(profile.id) : null;
  },

  methods: {
    //set active sub menu links e.g. last reco, accuracy achieved
    setActiveSubMenuLink(label) {
      if (label == 'TRADE') {
        this.$store.commit('commitTradeMenu', 'TRADE');
      } else if (label == 'ORDERS') {
        this.$store.commit('commitTradeMenu', 'ORDERS');
      } else if (label == 'POSITION') {
        this.$store.commit('commitTradeMenu', 'POSITION');
      } else if (label == 'HOLIDINGS') {
        this.$store.commit('commitTradeMenu', 'HOLIDINGS');
      } else if (label == 'TRADE') {
        this.$store.commit('commitTradeMenu', 'TRADE');
      } else if (label == 'FUNDS') {
        this.$store.commit('commitTradeMenu', 'FUNDS');
      }

      // on menu select scroll page to top
      var elmnt = document.getElementsByClassName('Trading')[0];
      scrollTo(elmnt, 0, 100);
    },
  },

  computed: {
    userProfile() {
      return JSON.parse(localStorage.getItem('profile'));
    },

    activeTradingMenu() {
      return this.$store.state.active_trade_menu;
    },
  },
};
</script>

<style lang="scss">
@import '../css/variable.scss';
@import '../css/common.scss';

.Trading {
  min-height: 92vh;
  background-color: $page-background-color;
  padding: 60px 0 70px 0;
}
.Trading .reco-details-container {
  .sub-menu-section {
    top: 60px;
  }
  // width: calc(100% - 265px);
  // margin-left: 265px;
  // min-height: 100vh;
}
.Trading .reco-details-section {
  padding: 65px 10px 0 10px;
}
.Trading .sub-menu-bar-wrapper {
  background: $page-background-color;
  // width: calc(100% - 265px);
}

.no-data-labels {
  position: absolute;
  top: 20px;
  left: 0;
  right: 0;
}

@media screen and (max-width: 1283px) {
  .Trading {
    padding: 50px 0 70px 0;
  }
  .Trading .sub-menu-bar {
    width: 100%;
  }
  .Trading .reco-details-container,
  .Trading .sub-menu-bar-wrapper,
  .Trading .footer-section {
    width: 100%;
    margin-left: 0;
  }
  .Trading .sideBarSection {
    display: none;
  }
}
@media screen and (max-width: 700px) {
  .Trading .reco-details-section {
    padding: 60px 10px 70px 10px !important;
  }

  .Trading .sub-menu-bar {
    .sub-menu-bar-link {
      margin: 0 10px;
    }
  }
}
</style>
